export default () => ({
    ranks: []
})
